<template>
  <div class="content">
    <v-card>
      <v-card-title>
        Enviar Push Notifications
      </v-card-title>

      <v-card-text>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-autocomplete
                  multiple
                  chips
                  class="input"
                  :items="clients"
                  item-text="name"
                  item-value="id"
                  label="Cliente:"
                  v-model="condominios.id_list"
                  prepend-icon="mdi-office-building"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  label="Título"
                  class="mt-3 input"
                  v-model="condominios.title"
                  prepend-icon="mdi-signature-text"
                />
              </v-col>
            </v-flex>
          </v-row>

          <v-row>
            <v-flex xs12 md12 sm12>
              <v-col align="start">
                <v-textarea
                  prepend-icon="mdi-sticker-text"
                  label="Mensagem"
                  v-model="condominios.text"
                />
              </v-col>
            </v-flex>
          </v-row>

          <v-row justify="end">
            <v-flex xs12 md3 sm6>
              <v-col align="center">
                <v-btn block class="white--text" color="success" @click="send">
                  Enviar
                </v-btn>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ClientController from '../../controllers/ClientController';
import PushNotificationsController from '../../controllers/PushNotificationsController';

export default {
  created() {
    this.clientController = new ClientController(this.$resource);
    this.getClients();
  },

  data() {
    return {
      pushNotificationsController: new PushNotificationsController(
        this.$resource
      ),
      clients: [],
      condominios: {
        id_list: [],
        title: '',
        text: '',
      },
    };
  },

  methods: {
    getClients() {
      this.clientController
        .getAllClients()
        .then(clients => (this.clients = clients));
    },

    async send() {
      try {
        const res = await this.pushNotificationsController.sendPushNotification(
          this.condominios,
        );

        this.$awn.success(
          `Push Notification enviado. Sucesso: ${res.body.success}, Falhou: ${res.body.failure} `
        );
      } catch (err) {
        this.$awn.alert(error);
      }
    },
  },
};
</script>

<style>
.container {
  max-width: 100%;
  padding-left: 20%;
}
.input {
  width: 600px;
}
</style>
